import { ADD_USER_DETAIL, PROFILE_DATA, UPDATE_PROFILE } from "./types";
import { baseUrl } from "../constants/const";
import { apiCall } from "../../api";

export const addUserDetail = (data, successCb, failureCb) => async (dispatch) => {
    let config = {
        method: "post",
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem("token")}` },
        url: `${baseUrl}user/add_detail`,
        data
    };

    let response = await apiCall(config, dispatch)
    console.log(response)
    if (response?.data?.status) {
        console.log(response?.data,"running in successCb")
        successCb(response?.data)
        dispatch({
            type: ADD_USER_DETAIL,
            payload: response?.data
        })
    } else {
        console.log("running in failureCb")
        failureCb(response?.data)
    }
};

export const getProfileData = (successCb, failureCb) => async (dispatch) => {
    let config = {
        method: "post",
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem("token")}` },
        url: `${baseUrl}user/user_detail`,
    };

    let response = await apiCall(config, dispatch)
    if (response?.data?.status) {
        dispatch({
            type: PROFILE_DATA,
            payload: response?.data
        })
        successCb(response?.data)
    } else {
        failureCb(response?.data)
    }
};

export const updateUserProfile = ({ formData, successCb, failureCb }) => async dispatch => {
    let config = {
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data', Authorization: `Bearer ${localStorage.getItem("token")}` },
        url: `${baseUrl}user/update_profile`,
        data: formData
    }
    try {
        let response = await apiCall(config, dispatch)
        if (response?.data?.status) {
            dispatch({
                type: UPDATE_PROFILE,
                payload: response?.data
            })
            //reducer mein set kr aa
            successCb(response?.data)
        } else {
            failureCb(response?.data)
        }

    } catch (error) {
        failureCb(error?.message)
    }
};

export const updateAcacdemyName = (data, successCb, failureCb) => async (dispatch) => {
    let config = {
        method: "post",
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${localStorage.getItem("token")}` },
        url: `${baseUrl}user/update_academy_name`,
        data
    };

    let response = await apiCall(config, dispatch)
    if (response?.data?.status) {
        successCb(response?.data)
    } else {
        failureCb(response?.data)
    }
};
